// extracted by mini-css-extract-plugin
module.exports = {"highlight":"render_highlighted_parts-module__highlight--1PLKq"};